<template>
  <div class="mit-password-forgot-page mit-page">
    <v-container>
        <v-card v-if="!finished">
            <v-card-title>Forgot Password</v-card-title>
            <v-card-subtitle>Enter your CSAIL id to start the reset password process</v-card-subtitle>
            <v-card-text>
              <v-form ref="linkForm" v-model="valid" lazy-validation>
                  <v-text-field class="pb-10 pt-5" v-model="userId" label="Enter CSAIL id" :rules="rules.id"></v-text-field>
                  <v-btn color="primary" @click="submit()">Submit</v-btn>
              </v-form>
            </v-card-text>
        </v-card>
        <v-card v-if="finished">
            <v-card-title>{{resultModel.title}}</v-card-title>
            <v-card-text>
                <v-col v-if="loading" class="d-flex justify-center align-center">
                  <v-row>
                    <BaseMitLoading class="pa-10"/>
                  </v-row>
                </v-col>

                <div v-if="!loading" class="pa-10">
                  <div class="pb-10"> {{resultModel.message}}</div>
                  <v-btn v-if="resultModel.success" color="primary" to="/">Go Home</v-btn>
                  <v-btn v-if="!resultModel.success" color="primary" @click="retry()">Retry</v-btn>
                </div>

            </v-card-text>
        </v-card>
      </v-container>
  </div>
</template>

<script>
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
  import MitUserManagementService from '../services/MitUserManagementService.js';
  import MitTokenService from '../services/MitTokenService.js';

  export default {
    name: 'MitPasswordResetFromLinkPage',
    components: {
      BaseMitLoading
    },
    data: function() {
      return {
        userId:'',
        resultModel:{
          success:false,
          title:'',
          message:''
        },
        valid:false,
        rules: {
          //rules for password come from backend since they are needed for api level validation, one set of rules for everyone :)
          id:[
            v => !!v || 'CSAIL id is required',
          ]
        },
        loading:true,//making the request
        finished:false
      }
    },
    created() {

    },
    methods: {
      retry(){
        //reset the state
        this.finished = false;
        this.resultModel.title = '';
        this.resultModel.message = '';
      },
      submit() {
        if(this.$refs.linkForm.validate()){
          this.finished = true;
          this.loading = true;

          MitUserManagementService.requestPasswordReset(this.userId)
            .then((result) => {
              this.loading = false;
              this.resultModel.success = true;
              this.resultModel.title = 'Success';
              this.resultModel.message = 'Check your email to finish the reset process.';
            })
            .catch((error) => {
              this.resultModel.success = false;
              this.resultModel.title = 'Error';
              this.resultModel.message = 'Reason: '+error;

              this.loading = false;
            });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
